import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CardComponent } from '../../ui/card/card.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { addDays } from 'date-fns';
import Swal from 'sweetalert2';
import { AccountService } from 'src/app/shared/services/account.service';
import { BUSINESS_UNIT } from 'src/app/_constants/appMessages';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { NeolabSyncService } from 'src/app/shared/services/neolab-sync.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-neolab-sync-modal',
  imports: [CommonModule, CardComponent, FormsModule, ReactiveFormsModule, TranslateModule, NgSelectModule,
    NgbTooltipModule, FontAwesomeModule],
  templateUrl: './neolab-sync-modal.component.html',
  styleUrl: './neolab-sync-modal.component.scss'
})
export class NeolabSyncModalComponent implements OnInit {
  faCircleNotch = faCircleNotch;
  dateFrom = new Date();
  dateTo = new Date();
  bussinesUnitStorage = JSON.parse(localStorage.getItem(BUSINESS_UNIT));

  params = {
    pj: this.accountService.context.businessUnit,
    dateFrom: null,
    dateTo: null,
  };

  constructor(
    private translate: TranslateService,
    private accountService: AccountService,
    private datePipe: DatePipe,
    public bsModalRef: BsModalRef,
    private neolabSync: NeolabSyncService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.dateTo = addDays(this.dateTo, 1);
    this.dateFrom = addDays(this.dateFrom, -30);

    this.confirmSync();
  }

  confirmSync() {
    Swal.fire({
      title: this.translate.instant("Neolab sinkronizacija"),
      html: `Želite li izvršiti sinkronizaciju na poslovnu jedinicu
                       <b>${this.bussinesUnitStorage.naziv}</b> Za period od 
                       <b>${this.datePipe.transform(this.dateFrom, "dd.MM.yyyy")}</b> do 
                       <b>${this.datePipe.transform(this.dateTo, "dd.MM.yyyy")}</b> ?`,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "DA",
      cancelButtonText: "NE",
      icon: 'question',
    }).then(result => {
      if (result.isConfirmed) {
        this.sync();
      }
      else {
        this.closeModal();
      }
    });
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  sync() {
    this.params.dateFrom = this.dateFrom;
    this.params.dateTo = this.dateTo;
    this.neolabSync.sync(this.params).subscribe(resp => {
      this.toastr.success("Uspješno sinkronizirano " + resp.body.item.faktura + ' faktura');
      this.closeModal();
    }, error => {
      this.toastr.error(error?.error?.errors[0]?.message)
    })
  }
}
